import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { matchRoutes } from "react-router-dom";
import "./App.css";
import SEO from "./components/SEO";
import TopBar from "./NavBar/TopBar";
import Navbar from "./NavBar/Navbar";
import Footer from "./Footer/Footer";
import React, { useEffect, useState } from "react";
import { Suspense, lazy } from "react";
import Loading from "./Loading/Loading";
import ScrollToTop from "./Extra/ScrollToTop";
import ScrollToTopButton from "./Extra/ScrollToTopButton";
const AboutBanner = lazy(() => import("./About-Us/About-Company/AboutBanner"));
const CompanyProfile = lazy(() =>
  import("./About-Us/About-Company/CompanyProfile")
);
const FAQ = lazy(() => import("./About-Us/About-Company/FAQ"));
const History = lazy(() => import("./About-Us/About-Company/History"));
const AboutItdose = lazy(() => import("./About-Us/About-Company/AboutItdose"));
const AwardCertificate = lazy(() =>
  import("./About-Us/About-Company/AwardCertificate")
);
const CompanyInfo = lazy(() => import("./About-Us/About-Company/CompanyInfo"));
const CompanyLocation = lazy(() =>
  import("./About-Us/About-Company/CompanyLocation")
);
const VisionBanner = lazy(() =>
  import("./About-Us/Vision-Mission-Values/VisionBanner")
);
const VisionAbout = lazy(() =>
  import("./About-Us/Vision-Mission-Values/VisionAbout")
);
const TeamBanner = lazy(() => import("./About-Us/Our-Team/TeamBanner"));
const CeoDesk = lazy(() => import("./About-Us/Our-Team/CeoDesk"));
const MeetOurTeam = lazy(() => import("./About-Us/Our-Team/MeetOurTeam"));
const CelebratingMoments = lazy(() =>
  import("./About-Us/Our-Team/CelebratingMoments")
);
const HospediaBanner = lazy(() => import("./Products/Hospedia/HospediaBanner"));
const HospediaAbout = lazy(() => import("./Products/Hospedia/HospediaAbout"));
const ModulesFeatures = lazy(() =>
  import("./Products/Hospedia/ModulesFeatures")
);
const AdditionFeatures = lazy(() =>
  import("./Products/Hospedia/AdditionFeatures")
);
const FeaturesAdvantages = lazy(() =>
  import("./Products/Hospedia/FeaturesAdvantages")
);
const InnopathBanner = lazy(() => import("./Products/Innopath/InnopathBanner"));
const ModulesFeaturesInnopath = lazy(() =>
  import("./Products/Innopath/ModulesFeaturesInnopath")
);
const InnopathAbout = lazy(() => import("./Products/Innopath/InnopathAbout"));
import DarkMode from "./Extra/DarkMode";
import ContactUsForm from "./Contact-Us/ContactUsForm";
import PrivacyPolicy from "./Footer/PrivacyPolicy";
import TermsAndCondition from "./Footer/TermsAndCondition";
import Blog from "./Pages/Blog";
import BlogDetail from "./Pages/BlogDetail";
// import WriterProfile from "./Pages/WriterProfile";

const ImageGallery = lazy(() => import("./Category/ImageGallery"));
const Country = lazy(() => import("./Category/Country"));
const CoursesSection = lazy(() => import("./Category/CoursesSection"));
const AboutSection = lazy(() => import("./Category/AboutSection"));
const OurServices = lazy(() => import("./Category/OurServices"));
const ProjectArea = lazy(() => import("./Category/ProjectArea"));
const MissionArea = lazy(() => import("./Category/MissionArea"));
const CounterSection = lazy(() => import("./Category/CounterSection"));
const NewsletterForm = lazy(() => import("./Category/NewsletterForm"));
const ScreenPreview = lazy(() => import("./Category/ScreenPreview"));
const YouTubeCarousel = lazy(() => import("./Category/YouTubeCarousel"));
const HomeContactForm = lazy(() => import("./Category/HomeContactForm"));
const ProductLogoCarousel = lazy(() =>
  import("./Category/ProductLogoCarousel")
);
const ContactUsPage = lazy(() => import("./Contact-Us/ContactUsPage"));
const ContactArea = lazy(() => import("./Contact-Us/ContactArea"));
const ContactUsYoutubeVideo = lazy(() =>
  import("./Contact-Us/ContactUsYoutubeVideo")
);
const ContactMap = lazy(() => import("./Contact-Us/ContactMap"));
const ClientsBanner = lazy(() => import("./Clients/ClientsBanner"));
const ClientsSection = lazy(() => import("./Clients/ClientsSection"));
const TestimonialCarousel = lazy(() => import("./Clients/TestimonialCarousel"));
const Page404 = lazy(() => import("./page404/page404"));

function Home() {
  return (
    <>

      <ImageGallery />
      <Country />
      <CoursesSection />
      <AboutSection />
      <OurServices />
      <ProjectArea />
      <MissionArea />
      <CounterSection />
      {/* <NewsletterForm /> */}
      <ScreenPreview />
      <YouTubeCarousel />
      <HomeContactForm />
      <ProductLogoCarousel />
    </>
  );
}

function ContactUs() {
  return (
    <>
      <ContactUsPage />
      <ContactArea />
      <ContactUsForm />
      {/* <ContactUsYoutubeVideo /> */}
      <ContactMap />
    </>
  );
}

function Clients() {
  return (
    <>
      <ClientsBanner />
      <ClientsSection />
      <TestimonialCarousel />
    </>
  );
}

function AboutCompany() {
  return (
    <>
      <AboutBanner />
      <CompanyProfile />
      <FAQ />
      <History />
      <AboutItdose />
      <AwardCertificate />
      <ContactUsForm />
      {/* <CompanyInfo/> */}
      <CompanyLocation />
    </>
  );
}

function VisionMissionValues() {
  return (
    <>
      <VisionBanner />
      <VisionAbout />
    </>
  );
}

function OurTeam() {
  return (
    <>
      <TeamBanner />
      <CeoDesk />
      <MeetOurTeam />
      <CelebratingMoments />
    </>
  );
}

function Hospedia() {
  return (
    <>
      <HospediaBanner />
      <HospediaAbout />
      <ModulesFeatures />
      <AdditionFeatures />
      <FeaturesAdvantages />
      <FAQ />
    </>
  );
}

function Innopath() {
  return (
    <>
      <InnopathBanner />
      <InnopathAbout />
      <ModulesFeaturesInnopath />
      <FAQ />
    </>
  );
}

// function App() {
//   return (
//     <>
//       <TopBar />
//       <Navbar />
//       <DarkMode />
//       <Suspense fallback={<Loading />}>
//         <ScrollToTop />
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/contact-us" element={<ContactUs />} />
//           <Route path="/clients-and-testimonials" element={<Clients />} />
//           <Route path="/about-the-company" element={<AboutCompany />} />
//           <Route
//             path="/vision-mission-and-values"
//             element={<VisionMissionValues />}
//           />
//           <Route path="/our-team" element={<OurTeam />} />
//           <Route
//             path="/hospital-information-and-management-system"
//             element={<Hospedia />}
//           />
//           <Route
//             path="/laboratory-information-and-management-system"
//             element={<Innopath />}
//           />
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//           <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
//           <Route path="*" element={<Page404 />} />
//           {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
//           {/* <Route path="/page404" element={<Page404 />} /> */}
//         </Routes>
//         <ScrollToTopButton />
//       </Suspense>
//       <Footer />
//     </>
//   );
// }

function App() {
  const location = useLocation();

  const routes = [
    { path: "/" },
    { path: "/contact-us" },
    { path: "/clients-and-testimonials" },
    { path: "/about-the-company" },
    { path: "/vision-mission-and-values" },
    { path: "/our-team" },
    { path: "/hospital-information-and-management-system" },
    { path: "/laboratory-information-and-management-system" },
    { path: "/privacy-policy" },
    { path: "/terms-and-conditions" },
    { path: "/blog" },
    { path: "/blog/:slug" },
    // {path:"/writer/:slug"},
  ];

  const is404 = !matchRoutes(routes, location);

  return (
    <>
      {/* <SEO /> */}
      <TopBar />
      <Navbar />
      <DarkMode />
      <Suspense fallback={<Loading />}>
        <ScrollToTop />
        <SEO />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/clients-and-testimonials" element={<Clients />} />
          <Route path="/about-the-company" element={<AboutCompany />} />
          <Route path="/vision-mission-and-values" element={<VisionMissionValues />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/hospital-information-and-management-system" element={<Hospedia />} />
          <Route path="/laboratory-information-and-management-system" element={<Innopath />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          {/* <Route path="/writer/:slug" element={<WriterProfile />} /> */}
          <Route path="*" element={<Page404 />} />
        </Routes>

        <ScrollToTopButton />
      </Suspense>
      {!is404 && <Footer />}
    </>
    
  );
}






export default App;
